import React, { useEffect, useState } from "react";
import "../../css/RelatedOffers.css";

import { fetchFilteredOffers } from "../../apiIntegration/getOfferDataFromFirebase";
import { getUserLocation } from "../getUserLocation";
import { HomeScreenOfferTemplate } from "./offerTemplates/HomeScreenOfferTemplate";
import { BlinkBlur } from "react-loading-indicators";

export const RelatedOffers = ({ currentOffer, distanceKm }) => {
	const [loading, setLoading] = useState(true);
	const [offers, setOffers] = useState([]);

	useEffect(() => {
		const loadData = async () => {
			try {
				setLoading(true);
				const location = await getUserLocation();
				const data = await fetchFilteredOffers({
					category: currentOffer.category,
					subCategory: "all",
					userLocation: location,
					distanceKm,
				});

				setOffers(data || []);
			} catch (error) {
				console.log(error);
			} finally {
				setLoading(false);
			}
		};

		loadData();
	}, [currentOffer, distanceKm]);
	if (loading) {
		return (
			<div className="px-3 mt-5 nearBuSection">
				<BlinkBlur
					color="#494949"
					size="medium"
					text="Loading..."
					textColor="#ffffff"
				/>
			</div>
		);
	}
	if (!offers?.length) {
		return (
			<div className="px-3 mt-4">
				<p>No nearby offers found increase distance</p>
			</div>
		);
	}

	return (
		<div className="related-offers-section">
			<div className="related-offers-header">
				<h4>Related Offers</h4>
			</div>

			<div className="horizontal-scroll-offers">
				{offers.map((offer) => (
					<div key={offer.offerId} className="horizontal-offer-card">
						<HomeScreenOfferTemplate
							data={offer}
							type={offer.offerTemplate || "dark"}
							previewUrl={offer.image}
							distanceKm={distanceKm}
						/>
					</div>
				))}
			</div>
		</div>
	);
};
